@if (column.propertyCode !== 'systemIcons') {
    <div class="cell-content">
        @if (column.type === PropertyType.Date) {
            <span [ngClass]="{ unread: !row.isRead }" [title]="row | avmFolderCellPipe: column">{{ row | avmFolderCellPipe: column | date: column.displayFormat }}</span>
        } @else if (column.type === PropertyType.DateAndTime) {
            <span [ngClass]="{ unread: !row.isRead }" [title]="row | avmFolderCellPipe: column">{{ row | avmFolderCellPipe: column | date: column.displayFormat }}</span>
        } @else if (column.type === PropertyType.Color) {
            <div [ngClass]="{ unread: !row.isRead }" class="color-indicator bak-{{ row | avmFolderCellPipe: column }}-color">
                @if ((row | avmFolderCellPipe: column) === '1') {
                    <span>Aucune</span>
                }
            </div>
        } @else if (column.type === PropertyType.Link) {
            <span title="{{ row | avmFolderCellPipe: column | avmLink: 'DisplayName' : true }}">
                @if (row | avmFolderCellPipe: column) {
                    <a href="{{ row | avmFolderCellPipe: column | avmLink: 'Url' : true }}" target="_blank" class="link-cell-value">
                        {{ row | avmFolderCellPipe: column | avmLink: 'DisplayName' : true }}
                    </a>
                }
                @if (!(row | avmFolderCellPipe: column)) {
                    <span></span>
                }
            </span>
        } @else {
            <span [ngClass]="{ unread: !row.isRead }" [title]="row | avmFolderCellPipe: column">{{ row | avmFolderCellPipe: column }}</span>
        }
    </div>
} @else {
    <div class="system-icons">
        @if (isExpandCommentsMode) {
            <!-- Cas de l'affichage des commentaires dans la ligne détail -->
            @if (row.hasComment) {
                @if (isExpanded) {
                    <div class="cell-content icon-cell-content">
                        <fa-icon
                            [icon]="collapseIcon"
                            class="collapse-icon"
                            matTooltip="Replier les commentaires"
                            matTooltipPosition="below"
                            (click)="onExpandIconClick()"></fa-icon>
                    </div>
                } @else {
                    <div class="cell-content icon-cell-content">
                        <fa-icon [icon]="expandIcon" class="expand-icon" matTooltip="Déplier les commentaires" matTooltipPosition="below" (click)="onExpandIconClick()"></fa-icon>
                    </div>
                }
            } @else {
                <div class="cell-content icon-cell-content empty-first-icon"></div>
            }
        } @else {
            <!-- Cas de l'affichage des documents dans la ligne détail -->
            @if (row.hasDocument) {
                @if (isExpanded) {
                    <div class="cell-content icon-cell-content">
                        <fa-icon
                            [icon]="collapseIcon"
                            class="collapse-icon"
                            matTooltip="Replier la liste des documents"
                            matTooltipPosition="below"
                            (click)="onExpandIconClick()"></fa-icon>
                    </div>
                } @else {
                    <div class="cell-content icon-cell-content">
                        <fa-icon
                            [icon]="expandIcon"
                            class="expand-icon"
                            matTooltip="Déplier la liste des documents"
                            matTooltipPosition="below"
                            (click)="onExpandIconClick()"></fa-icon>
                    </div>
                }
            } @else {
                <div class="cell-content icon-cell-content empty-first-icon"></div>
            }
        }

        @switch (row['lockedType']) {
            @case (LockedType.LockedByCurrentUser) {
                <div class="cell-content icon-cell-content">
                    <fa-icon [icon]="lockByMeIcon" class="lock-by-me-icon" matTooltip="Ouvert par moi" matTooltipPosition="below"></fa-icon>
                </div>
            }
            @case (LockedType.LockedByOtherUser) {
                <div class="cell-content icon-cell-content">
                    <fa-icon [icon]="lockByOtherIcon" class="lock-by-other-icon" [matTooltip]="row | avmLockedByPipe" matTooltipPosition="below"></fa-icon>
                </div>
            }
            @default {
                <div class="cell-content icon-cell-content empty-second-icon"></div>
            }
        }

        @if (row['isRead'] === true) {
            <div class="cell-content icon-cell-content empty-third-icon"></div>
        } @else {
            <div class="cell-content icon-cell-content">
                <fa-icon [icon]="unreadIcon" class="unreadIcon" matTooltip="Non lu" matTooltipPosition="below"></fa-icon>
            </div>
        }

        @if (row['hasWarning'] === true) {
            <div class="cell-content icon-cell-content">
                <fa-icon [icon]="warningIcon" class="warningIcon" matTooltip="Attention de l'utilisateur necessaire" matTooltipPosition="below"></fa-icon>
            </div>
        } @else if (row['hasNotification'] === true) {
            <div class="cell-content icon-cell-content">
                <fa-icon [icon]="notificationIcon" class="notificationIcon" matTooltip="Présence de notification(s)" matTooltipPosition="below"></fa-icon>
            </div>
        } @else {
            <div class="cell-content icon-cell-content empty-fourth-icon"></div>
        }

        @if (!isFollowedFoldersList) {
            @if (row['isFollowed'] === true) {
                <div class="cell-content icon-cell-content">
                    <fa-icon [icon]="isFollowedIcon" class="isFollowedIcon" matTooltip="Dossier suivi" matTooltipPosition="below"></fa-icon>
                </div>
            } @else {
                <div class="cell-content icon-cell-content empty-fourth-icon"></div>
            }
        }
    </div>
}
